import { render, staticRenderFns } from "./Specialists.vue?vue&type=template&id=0c87d367&scoped=true&"
var script = {}
import style0 from "./Specialists.vue?vue&type=style&index=0&id=0c87d367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87d367",
  null
  
)

export default component.exports